<template>
  <issue-severity class="issue-severity column" :issue="item" :is-translation='isTranslation'/>
</template>

<script>
import IssueSeverity from '@/components/issue/IssueSeverity.vue';

export default {
  name: 'IssueSeverityTableCell',
  components: {
    IssueSeverity,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    column: {
      type: Object,
      required: true,
    },
    isTranslation: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
